// @flow

import './style/index.scss';
import * as React from 'react';
import staticBootstrap from 'utils/staticBootstrap';
import bootstrap from 'utils/bootstrap';
import Stores from './stores';
import Elements from './elements';

import type { ElementsMap } from '../../utils/staticBootstrap';

const $$app = document.getElementById('app');
if ($$app) {
    bootstrap((): React$ComponentType<*> => {
        Stores.init();
        const App = React.lazy(() => import('./components/App'));
        return App;
    });
} else {
    staticBootstrap((): ElementsMap => {
        Stores.init();
        return Elements;
    });
}
